import it from "./it.json"
import en from "./en.json"

export const defaultLocale = "it"

export const languages = {
  it,
  en
}
